import "babel-polyfill";
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import VueTheMask from "vue-the-mask";
import VueMoment from "vue-moment";
import BrowserDetect from "vue-browser-detect-plugin";
import money from "v-money";
import axios from "axios";

Vue.config.productionTip = false;

Vue.use(VueTheMask);
Vue.use(VueMoment);
Vue.use(BrowserDetect);
Vue.use(money);

new Vue({
  i18n,
  router,
  store: store.original,
  vuetify,
  render: h => h(App)
}).$mount("#app");
